import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'clsx';

import SlideContent from 'src/components/SlideContent';
import styles from 'src/containers/SlideContentContainer.scss';


const SlideContentContainer = ({
  isCenterAlign,
  darkFontVersion,
  title,
  offerCounter,
  isCounterOverButton,
  subtitle,
  buttons
}) => (
  <div
    className={ classNames(
      styles['content-container'],
      {
        [styles['content-container--light']]: darkFontVersion,
        [styles['content-container--centerAlign']]: isCenterAlign
      }
    ) }
    data-test="section-content-container"
  >
    <div className={ classNames(styles['slide-content']) }>
      <SlideContent
        buttons={ buttons }
        isCounterOverButton={ isCounterOverButton }
        offerCounter={ offerCounter }
        subtitle={ subtitle }
        title={ title }
      />
    </div>
  </div>
);

SlideContentContainer.propTypes = {
  buttons: PropTypes.arrayOf(Object).isRequired,
  darkFontVersion: PropTypes.bool.isRequired,
  isCenterAlign: PropTypes.bool.isRequired,
  isCounterOverButton: PropTypes.bool.isRequired,
  offerCounter: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export default SlideContentContainer;
